import { SERVICE_CLASS_COLORS, SERVICE_CLASS_LABELS, type ServiceClass } from '@kontor/shared';
import './service-class.css';

/**
 * Kennzeichen der Serviceklasse eines Auftrags im Chauffeur-Betrieb: ein Kreis mit zartem Verlauf (Business grün, First Class gold, Business Van violett, Hybrid türkis) und die Bezeichnung.
 * Elektro zeigt statt des Kreises einen grünen Blitz. Ohne Klasse erscheint nichts.
 */
export function ServiceClassBadge({ value }: { value: ServiceClass | null | undefined }) {
  if (!value) return null;
  const color = SERVICE_CLASS_COLORS[value];
  return (
    <span className="class-badge" title={`Verlangte Serviceklasse: ${SERVICE_CLASS_LABELS[value]}`}>
      {color.icon === 'bolt' ? (
        <svg className="class-badge__bolt" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
          <defs>
            <linearGradient id="class-bolt" x1="0" y1="0" x2="1" y2="1">
              <stop offset="0" stopColor={color.from} />
              <stop offset="1" stopColor={color.to} />
            </linearGradient>
          </defs>
          <path fill="url(#class-bolt)" d="M13.5 2 5 13.5h5.2L9.5 22 19 9.8h-5.4z" />
        </svg>
      ) : (
        <span className="class-badge__dot" style={{ background: `linear-gradient(135deg, ${color.from}, ${color.to})` }} aria-hidden="true" />
      )}
      <span>{SERVICE_CLASS_LABELS[value]}</span>
    </span>
  );
}
